// extracted by mini-css-extract-plugin
var _1 = "ra-score-averages";
var _2 = "ra-score";
var _3 = "ra-score-result";
var _4 = "ra-score-result-item";
var _5 = "ra-score-result-name";
var _6 = "ra-score-result-percentage";
export { _1 as "scoreAveragesCls", _2 as "scoreCls", _3 as "scoreResultCls", _4 as "scoreResultItemCls", _5 as "scoreResultNameCls", _6 as "scoreResultPercentageCls" }
